/* istanbul ignore file */
//   _____  ______ _      ______ _______ ______   __  __ ______
//  |  __ \|  ____| |    |  ____|__   __|  ____| |  \/  |  ____|
//  | |  | | |__  | |    | |__     | |  | |__    | \  / | |__
//  | |  | |  __| | |    |  __|    | |  |  __|   | |\/| |  __|
//  | |__| | |____| |____| |____   | |  | |____  | |  | | |____
//  |_____/|______|______|______|  |_|  |______| |_|  |_|______|
//
// These functions were copied from the @fs/zion-sls package to avoid dependency issues.
// TODO: Remove this file once the dependency issues are resolved with version 2.1.0 of @fs/zion-sls in this repo.

import { getNestedSubelementsByType, getOtherPersonId } from '@fs/zion-sls'

/**
 * Retrieves all relationships of a specific type from a person or from a provided array of relationships.
 *
 * @param {Object} params - The parameters object.
 * @param {Object} params.person - The PERSON object.
 * @param {Array} [params.relationships] - Optional array of RELATIONSHIP objects to use instead of fetching from the person.
 * @param {string} params.relType - The type of relationship to filter by. E.g.: 'COUPLE', 'PARENT_CHILD', etc.
 * @returns {Array} An array of relationship objects matching the specified type.
 */
export const getPersonRelationshipsByType = (params) => {
  const { person, relationships, relType } = params
  const allRelationships = relationships || getNestedSubelementsByType(person, 'RELATIONSHIP')

  return allRelationships.filter((relationship) => relationship.relType === relType)
}

/**
 * Retrieves all relationships between two people.
 *
 * @param {Object} params - The parameters object.
 * @param {Object} params.person - The PERSON object.
 * @param {string} params.otherPersonId - The ID of the other person to find relationships with.
 * @returns {Array} An array of relationship objects between the two people.
 */
export const getRelationshipsBetweenTwoPeople = (params) => {
  const { person, otherPersonId } = params
  const allRelationships = getNestedSubelementsByType(person, 'RELATIONSHIP')

  return allRelationships.filter((relationship) => {
    const otherId = getOtherPersonId(relationship, person)
    return otherId === otherPersonId
  })
}

/**
 * Retrieves the relationships of a specific type between two people.
 *
 * @param {Object} params - The parameters object.
 * @param {Object} params.person - The PERSON object.
 * @param {string} params.otherPersonId - The ID of the other person.
 * @param {string} params.relType - The type of relationship to filter by.
 * @returns {Array} An array of relationship objects matching the specified type.
 */
export const getRelationshipsBetweenTwoPeopleByType = (params) => {
  const { person, otherPersonId, relType } = params
  const relationshipsBetweenTwo = getRelationshipsBetweenTwoPeople({ person, otherPersonId })

  return relationshipsBetweenTwo.filter((relationship) => relationship.relType === relType)
}
